import React, { Component } from 'react';
import {
    CCol,
    CRow,
    CButton,
    CPopover,
    CLink,
    CModal,
    CModalHeader,
    CModalBody,
    CModalFooter,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from 'src/_helpers';
import { TagsComponentContainer } from 'src/containers/tags/TagsComponentContainer';

class DocView extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {

    }

    updateObjectTags(item) {
        this.props.updateField(item, 'tags');
    }

    render() {
        let { item, docs, categories } = this.props;
        let category = helps.getItemFromArr(categories, item.category_id);
        let item_replace_for = !helps.isEmpty(item.replace_for) ? helps.getItemFromArr(docs, item.replace_for) : {};
        return (
            <CModal
                key={'modal-' + item}
                size='xl'
                show={this.props.modals.includes(item.id)}
                onClose={() => { this.props.toggleModal(item.id) }}
                className='text-left'
            >
                <CModalHeader closeButton>
                    <div>
                        <h3>{item.title}</h3>
                    </div>
                </CModalHeader>
                <CModalBody>
                    <CRow className={'mb-3'}>
                        <CCol md={2}>Tiêu đề:</CCol>
                        <CCol md={9}><b>{item.title}</b></CCol>
                    </CRow>
                    <CRow className={'mb-3'}>
                        <CCol md={2}>Số văn bản:</CCol>
                        <CCol md={4}><b>{item.number}</b></CCol>
                        <CCol md={2}>Phân loại:</CCol>
                        <CCol md={4}><b>{category.name}</b></CCol>
                    </CRow>
                    <CRow className={'mb-3'}>
                        <CCol md={2}>Ngày Hiệu Lực/Ban Hành:</CCol>
                        <CCol md={4}><b>{helps.formatDate_from_Timestamp(item.start_date)}</b></CCol>
                        <CCol md={2}>Nhãn:</CCol>
                        <CCol md={4}>
                            <TagsComponentContainer {... this.props} object='docs' object_id={item.id} object_value={item} updateObjectTags={() => { this.updateObjectTags(item) }} />
                        </CCol>
                    </CRow>
                    <CRow className={'mb-3'}>
                        <CCol md={2}>Nội dung:</CCol>
                        <CCol md={10}>{item.content}</CCol>
                    </CRow>
                    <hr />
                    <CRow className={'mb-3'}>
                        <CCol md={2}>Đính kèm:</CCol>
                        <CCol md={10}>
                            {!helps.isEmpty(item.attachment) && item.attachment.length > 0 && item.attachment.map((_file) => {
                                return (
                                    <div key={item.id + '-' + _file.name} >
                                        <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                        <CPopover
                                            content={_file.name}
                                        >
                                            <CLink href={_file.url} target='_blank'> {_file.name}</CLink>
                                        </CPopover>
                                    </div>
                                )

                            })}
                        </CCol>
                    </CRow>
                    {!helps.isEmpty(item.replace_for) && !helps.isEmpty(item_replace_for) && <>
                        <hr />
                        <CRow className={'mb-3'}>
                            <CCol md={2}>Thay thế cho:</CCol>
                            <CCol md={10}>
                                <b>{item_replace_for.title}</b> - <i><u>Số:</u></i> <b>{item_replace_for.number}</b> - <i><u>Ngày:</u></i> <b>{helps.formatDate_from_Timestamp(item_replace_for.start_date)}</b>
                            </CCol>
                        </CRow>
                    </>}
                </CModalBody>
                <CModalFooter>
                    <CRow className="mb-3">
                        <CCol md={12}>
                            <CButton type="button" size='sm' color="secondary" onClick={() => this.props.toggleModal(item.id)}>
                                <CIcon name="cil-x-circle" className="mfe-1 mt-0"></CIcon>
                                Đóng
                            </CButton>
                        </CCol>
                    </CRow>
                </CModalFooter>
            </CModal>
        )
    }
}
export default DocView;

